import * as React from "react";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { decorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";

const CONTENT_ID_COUNT = 6;
export const CardComparisonFeatureSectionEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [
    cardStatusFeatureOneIcon,
    cardStatusFeatureOneDescription,
    cardStatusFeatureTwoIcon,
    cardStatusFeatureTwoDescription,
    cardStatusFeatureThreeIcon,
    cardStatusFeatureThreeDescription,
  ] = React.useMemo(() => items.map((item) => decorateEditorialHtml(item.text)), []);

  return (
    <div className="uitk-type-center">
      <UitkLayoutGrid columns={12} space="six">
        <UitkLayoutGridItem colSpan={4}>
          <div>
            <div dangerouslySetInnerHTML={cardStatusFeatureOneIcon} />
            <UitkText align="center" size={200} weight="medium">
              <div
                dangerouslySetInnerHTML={cardStatusFeatureOneDescription}
                className="all-t-padding-one all-b-padding-six"
              />
            </UitkText>
          </div>
        </UitkLayoutGridItem>

        <UitkLayoutGridItem colSpan={4}>
          <div>
            <div dangerouslySetInnerHTML={cardStatusFeatureTwoIcon} />
            <UitkText align="center" size={200} weight="medium">
              <div
                dangerouslySetInnerHTML={cardStatusFeatureTwoDescription}
                className="all-t-padding-one all-b-padding-six"
              />
            </UitkText>
          </div>
        </UitkLayoutGridItem>

        <UitkLayoutGridItem colSpan={4}>
          <div>
            <div dangerouslySetInnerHTML={cardStatusFeatureThreeIcon} />
            <UitkText align="center" size={200} weight="medium">
              <div
                dangerouslySetInnerHTML={cardStatusFeatureThreeDescription}
                className="all-t-padding-one all-b-padding-six"
              />
            </UitkText>
          </div>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
    </div>
  );
};

export default CardComparisonFeatureSectionEditorial;
